module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/funabashi_concept_03-787c75a3b03feaa4b428cd30e6afabcc.jpg";